import { GET_ONE } from "../../dataFetchActions";
import { CRUD_GET_ONE } from './crudconstants';

/** @deprecated We are phasing out legacy redux, use immi query instead */
export const crudGetOne = (resource, id, config = {}) => ({
  type: CRUD_GET_ONE,
  payload: { id, ...(config.additionalPayload || {}) },
  meta: {
    resource,
    context: config.context,
    customAction: config.customAction,
    id: id,
    type: GET_ONE, // Duplicate of fetch so that we can use this key in the reducer. It gets deleted in the fetch saga so that we don't get in an endless loop
    fetch: GET_ONE,
    onFailure: config.onFailure || {
      notification: {
        body: "notification.item_doesnt_exist",
        level: "warning",
      },
      redirectTo: "/",
      refresh: config.refresh,
    },
  },
});
